<template>
  <transition
      name="unpin-slide"
      @after-leave="afterLeave"
    >
    <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.demographics, collapsed: !expanded.demographics }">
        <div class="info-card-content">
          <div v-if="!expanded.demographics" class="flex flex-row items-center gap-2">
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                <path d="M8 5.83331C8.925 5.83331 9.66667 5.08331 9.66667 4.16665C9.66667 3.84998 9.58333 3.55831 9.425 3.30831L8 0.833313L6.575 3.30831C6.41667 3.55831 6.33333 3.84998 6.33333 4.16665C6.33333 5.08331 7.08333 5.83331 8 5.83331ZM13 8.33331H8.83333V6.66665H7.16667V8.33331H3C1.61667 8.33331 0.5 9.44998 0.5 10.8333V18.3333C0.5 18.7916 0.875 19.1666 1.33333 19.1666H14.6667C15.125 19.1666 15.5 18.7916 15.5 18.3333V10.8333C15.5 9.44998 14.3833 8.33331 13 8.33331ZM13.8333 17.5H2.16667V15C2.91667 14.9916 3.63333 14.6916 4.16667 14.1583L5.075 13.2666L5.96667 14.1583C7.05833 15.25 8.95833 15.2416 10.0417 14.1583L10.9417 13.2666L11.8333 14.1583C12.3667 14.6916 13.0833 14.9916 13.8333 15V17.5ZM13.8333 13.75C13.4083 13.7416 13.0083 13.5833 12.7083 13.275L10.9333 11.5L9.15 13.275C8.53333 13.8916 7.45833 13.8916 6.84167 13.275L5.06667 11.5L3.28333 13.275C2.99167 13.575 2.59167 13.7416 2.16667 13.75V10.8333C2.16667 10.375 2.54167 9.99998 3 9.99998H13C13.4583 9.99998 13.8333 10.375 13.8333 10.8333V13.75Z" fill="#374957"/>
              </svg>
            </div>
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M4.91732 6.16665C6.52565 6.16665 7.83398 7.47498 7.83398 9.08331C7.83398 10.6916 6.52565 12 4.91732 12C3.30898 12 2.00065 10.6916 2.00065 9.08331C2.00065 7.47498 3.30898 6.16665 4.91732 6.16665ZM4.91732 4.49998C2.38398 4.49998 0.333984 6.54998 0.333984 9.08331C0.333984 11.6166 2.38398 13.6666 4.91732 13.6666C7.45065 13.6666 9.50065 11.6166 9.50065 9.08331C9.50065 8.11665 9.20065 7.22498 8.69232 6.48331L12.0007 3.18331V5.33331H13.6673V0.333313H8.66732V1.99998H10.8173L7.50898 5.30831C6.77565 4.79998 5.88398 4.49998 4.91732 4.49998Z" fill="#374957"/>
              </svg>
            </div>
          </div>
          <div v-else class="info-row-group">
              <div class="info-row">
                  <div class="icon-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                      <path d="M8 5.83331C8.925 5.83331 9.66667 5.08331 9.66667 4.16665C9.66667 3.84998 9.58333 3.55831 9.425 3.30831L8 0.833313L6.575 3.30831C6.41667 3.55831 6.33333 3.84998 6.33333 4.16665C6.33333 5.08331 7.08333 5.83331 8 5.83331ZM13 8.33331H8.83333V6.66665H7.16667V8.33331H3C1.61667 8.33331 0.5 9.44998 0.5 10.8333V18.3333C0.5 18.7916 0.875 19.1666 1.33333 19.1666H14.6667C15.125 19.1666 15.5 18.7916 15.5 18.3333V10.8333C15.5 9.44998 14.3833 8.33331 13 8.33331ZM13.8333 17.5H2.16667V15C2.91667 14.9916 3.63333 14.6916 4.16667 14.1583L5.075 13.2666L5.96667 14.1583C7.05833 15.25 8.95833 15.2416 10.0417 14.1583L10.9417 13.2666L11.8333 14.1583C12.3667 14.6916 13.0833 14.9916 13.8333 15V17.5ZM13.8333 13.75C13.4083 13.7416 13.0083 13.5833 12.7083 13.275L10.9333 11.5L9.15 13.275C8.53333 13.8916 7.45833 13.8916 6.84167 13.275L5.06667 11.5L3.28333 13.275C2.99167 13.575 2.59167 13.7416 2.16667 13.75V10.8333C2.16667 10.375 2.54167 9.99998 3 9.99998H13C13.4583 9.99998 13.8333 10.375 13.8333 10.8333V13.75Z" fill="#25B8C2"/>
                    </svg>
                  </div>
                  <p v-if="!isEditingDob" class="info-text dob-editable" @click.stop="startEditDob">
                    {{ demographicsData.formattedBirthWithAge }}
                  </p>
                  <input
                    v-else
                    ref="dobInput"
                    v-model="dobInputValue"
                    type="text"
                    class="dob-input"
                    placeholder="MM/DD/YYYY"
                    maxlength="10"
                    @input="formatDobInput"
                    @blur="saveDob"
                    @keyup.enter="saveDob"
                    @keyup.esc="cancelEditDob"
                  />
              </div>
              <div class="info-row">
                  <div class="icon-container">
                    <svg v-if="demographicsData.gender === 'Male'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M4.91732 6.16665C6.52565 6.16665 7.83398 7.47498 7.83398 9.08331C7.83398 10.6916 6.52565 12 4.91732 12C3.30898 12 2.00065 10.6916 2.00065 9.08331C2.00065 7.47498 3.30898 6.16665 4.91732 6.16665ZM4.91732 4.49998C2.38398 4.49998 0.333984 6.54998 0.333984 9.08331C0.333984 11.6166 2.38398 13.6666 4.91732 13.6666C7.45065 13.6666 9.50065 11.6166 9.50065 9.08331C9.50065 8.11665 9.20065 7.22498 8.69232 6.48331L12.0007 3.18331V5.33331H13.6673V0.333313H8.66732V1.99998H10.8173L7.50898 5.30831C6.77565 4.79998 5.88398 4.49998 4.91732 4.49998Z" fill="#25B8C2"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#25B8C2">
                      <path d="M440-120v-80h-80v-80h80v-84q-79-14-129.5-75.5T260-582q0-91 64.5-154.5T480-800q91 0 155.5 63.5T700-582q0 81-50.5 142.5T520-364v84h80v80h-80v80h-80Zm40-320q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41Z"/>
                    </svg>
                  </div>
                  <p v-if="!isEditingGender" class="info-text gender-editable" @click.stop="startEditGender">
                    {{ demographicsData.gender }}
                  </p>
                  <el-select
                    v-else
                    ref="genderSelect"
                    v-model="genderSelectValue"
                    placeholder="Please Select"
                    class="gender-select"
                    size="small"
                    @change="onGenderChange"
                    @blur="saveGender"
                  >
                    <el-option label="Female" value="Female" />
                    <el-option label="Male" value="Male" />
                  </el-select>
              </div>
            </div>
            <div v-if="expanded.demographics" class="action-icons">
              <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
                <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
              </div>
              <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
                <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
              </div>
              <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('demographics')">
                <img src="@/assets/cardActions/collapse.svg" alt="Collapse" />
              </div>
            </div>
            <div v-else class="flex flex-row items-center gap-2">
              <div class="action-icon" @click.stop="toggleCard('demographics')">
                <img src="@/assets/cardActions/expand.svg" alt="Expand" />
              </div>
              <div class="drag-handle action-icon">
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </div>
            </div>
          </div>
          <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
            <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
              <template #prefix>
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </template>
            </FoldableButton>
            <div class="flex flex-row gap-1 justify-end">
              <FoldableButton text="Variable Properties" @click="handleVariableProperties">
                <template #prefix>
                  <img src="@/assets/cardActions/pt_variable.svg" alt="Variable Properties" />
                </template>
              </FoldableButton>
            </div>
          </div>
    </div>
  </transition>

  <PatientVariableDialog
    v-model:visible="showPtVariablesDialog"
    :ptVariables="ptVariables"
    :patientId="patientId"
  />
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useCardActions } from '@/composables/useCardActions';
import PatientVariableDialog from './PatientVariableDialog.vue';

const ptVariables = ['pt_sex', 'pt_dob']
const showPtVariablesDialog = ref(false)
const isEditingDob = ref(false)
const dobInputValue = ref('')
const dobInput = ref(null)
const dobSaveTimer = ref(null)
const isEditingGender = ref(false)
const genderSelectValue = ref('')
const genderSelect = ref(null)
const genderSaveTimer = ref(null)

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
  cardData: {
    type: Object,
    default: () => ({})
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  context: {
    type: String,
    default: 'pegboard'
  },
  externalVariableDialog: {
    type: Boolean,
    default: false
  }
})

// Define emits
const emit = defineEmits(['pin-card', 'unpin-card', 'open-variable-dialog'])

const store = useStore();

// Use the card actions composable
const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);

const isLeaving = ref(false);


const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};


// This is called after the leave animation finishes
const afterLeave = () => {
  emit('unpin-card', props.cardData); // parent removes the card
};


const expanded = ref({
  demographics: true,
})

const toggleCard = (cardType) => {
  expanded.value[cardType] = !expanded.value[cardType]
}

const handleVariableProperties = () => {
  if (!props.externalVariableDialog) {
    showPtVariablesDialog.value = true
  }
  emit('open-variable-dialog', ptVariables)
}

const startEditDob = () => {
  isEditingDob.value = true
  // Pre-load existing DOB if available (backend format: YYYY-MM-DD)
  if (demographicsData.value.dob) {
    const [year, month, day] = demographicsData.value.dob.split('-')
    dobInputValue.value = `${month}/${day}/${year}`
  } else {
    dobInputValue.value = ''
  }
  setTimeout(() => {
    dobInput.value?.focus()
  }, 0)
}

const formatDobInput = (event) => {
  let value = event.target.value
  // Remove all non-numeric characters
  value = value.replace(/\D/g, '')
  
  // Limit to 8 digits
  if (value.length > 8) {
    value = value.slice(0, 8)
  }
  
  // Format with slashes
  let formatted = ''
  if (value.length >= 1) {
    formatted = value.slice(0, 2)
    if (value.length >= 3) {
      formatted += '/' + value.slice(2, 4)
      if (value.length >= 5) {
        formatted += '/' + value.slice(4, 8)
      }
    }
  }
  
  dobInputValue.value = formatted
  
  // Clear existing timer
  if (dobSaveTimer.value) {
    clearTimeout(dobSaveTimer.value)
    dobSaveTimer.value = null
  }
  
  // If input is complete (MM/DD/YYYY), start 2-second timer
  if (formatted.length === 10) {
    dobSaveTimer.value = setTimeout(() => {
      saveDob()
    }, 2000)
  }
}

const saveDob = async () => {
  // Clear any pending timer
  if (dobSaveTimer.value) {
    clearTimeout(dobSaveTimer.value)
    dobSaveTimer.value = null
  }
  
  if (!dobInputValue.value || dobInputValue.value.length !== 10) {
    cancelEditDob()
    return
  }
  
  // Parse MM/DD/YYYY
  const parts = dobInputValue.value.split('/')
  if (parts.length !== 3) {
    cancelEditDob()
    return
  }
  
  const month = parseInt(parts[0])
  const day = parseInt(parts[1])
  const year = parseInt(parts[2])
  
  // Basic validation
  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > new Date().getFullYear()) {
    cancelEditDob()
    return
  }
  
  // Format as YYYY-MM-DD for API
  const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  
  try {
    // Call API first
    const { updatePatientInfoApi } = await import('@/api/patient')
    await updatePatientInfoApi({
      patient_id: patientId.value,
      birth_date: formattedDate
    })
    
    // Only update the store after successful API call
    await store.dispatch('myPatients/rooms/updatePatientDemographics', {
      roomId: props.patient,
      demographics: {
        dob: formattedDate
      }
    })
    
    // Unfocus the input
    if (dobInput.value) {
      dobInput.value.blur()
    }
    
    // Exit editing mode and clear input
    isEditingDob.value = false
    dobInputValue.value = ''
  } catch (error) {
    console.error('Failed to update DOB:', error)
    cancelEditDob()
  }
}

const cancelEditDob = () => {
  // Clear any pending timer
  if (dobSaveTimer.value) {
    clearTimeout(dobSaveTimer.value)
    dobSaveTimer.value = null
  }
  isEditingDob.value = false
  dobInputValue.value = ''
}

const startEditGender = () => {
  isEditingGender.value = true
  // Pre-load existing gender value
  const room = store.getters['myPatients/rooms/getPatientByRoomId'](props.patient)
  let actualGender = ''
  
  if (room?.patientBasicInfo?.gender) {
    actualGender = room.patientBasicInfo.gender
  } else {
    const backendUser = store.state.myPatients?.patientInfo?.backendusers?.[props.patient]
    if (backendUser?.patient_gender) {
      actualGender = backendUser.patient_gender
    }
  }
  
  // Only set if it's a valid gender value (Female or Male)
  if (actualGender === 'Female' || actualGender === 'Male') {
    genderSelectValue.value = actualGender
  } else {
    genderSelectValue.value = ''
  }
  
  setTimeout(() => {
    genderSelect.value?.focus()
  }, 0)
}

const onGenderChange = () => {
  // Clear existing timer
  if (genderSaveTimer.value) {
    clearTimeout(genderSaveTimer.value)
    genderSaveTimer.value = null
  }
  
  // If a valid selection is made, start 2-second timer
  if (genderSelectValue.value) {
    genderSaveTimer.value = setTimeout(() => {
      saveGender()
    }, 2000)
  }
}

const saveGender = async () => {
  // Clear any pending timer
  if (genderSaveTimer.value) {
    clearTimeout(genderSaveTimer.value)
    genderSaveTimer.value = null
  }
  
  if (!genderSelectValue.value) {
    cancelEditGender()
    return
  }
  
  try {
    // Call API first
    const { updatePatientInfoApi } = await import('@/api/patient')
    await updatePatientInfoApi({
      patient_id: patientId.value,
      gender: genderSelectValue.value
    })
    
    // Only update the store after successful API call
    await store.dispatch('myPatients/rooms/updatePatientDemographics', {
      roomId: props.patient,
      demographics: {
        gender: genderSelectValue.value
      }
    })
    
    // Unfocus the select
    if (genderSelect.value) {
      genderSelect.value.blur()
    }
    
    // Exit editing mode and clear selection
    isEditingGender.value = false
    genderSelectValue.value = ''
  } catch (error) {
    console.error('Failed to update gender:', error)
    cancelEditGender()
  }
}

const cancelEditGender = () => {
  // Clear any pending timer
  if (genderSaveTimer.value) {
    clearTimeout(genderSaveTimer.value)
    genderSaveTimer.value = null
  }
  isEditingGender.value = false
  genderSelectValue.value = ''
}

const calculateAge = (birthdate) => {
  if (!birthdate) return 'N/A';
  // Parse YYYY-MM-DD format directly without timezone conversion
  const [year, month, day] = birthdate.split('-').map(Number);
  const today = new Date();
  let age = today.getFullYear() - year;
  const monthDiff = today.getMonth() + 1 - month; // getMonth() is 0-indexed
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
    age--;
  }
  return age;
};

const patientId = computed(() => {
  const room = store.getters['myPatients/rooms/getPatientByRoomId'](props.patient);
  return room?.patientBasicInfo?.patientId || props.patient || '';
});

// Get demographics data — try rooms store first, fallback to backendusers
const demographicsData = computed(() => {
  const room = store.getters['myPatients/rooms/getPatientByRoomId'](props.patient);
  if (room?.patientBasicInfo) {
    const patient = room.patientBasicInfo;
    const age = calculateAge(patient.dob);
    const hasDob = !!patient.dob;
    let formattedBirth = 'N/A (Click to update)';
    if (patient.dob) {
      // Format YYYY-MM-DD to MM/DD/YYYY for display
      const [year, month, day] = patient.dob.split('-');
      formattedBirth = `${month}/${day}/${year} (${age} years old)`;
    }
    const genderDisplay = patient.gender && patient.gender !== 'N/A' 
      ? patient.gender 
      : 'N/A (Click to update)';
    return {
      gender: genderDisplay,
      age: age !== 'N/A' ? `${age}` : 'N/A',
      formattedBirthWithAge: formattedBirth,
      hasDob,
      dob: patient.dob,
      race: 'N/A',
      ethnicity: 'N/A'
    };
  }

  // Fallback: backendusers store (encounter notes context)
  const backendUser = store.state.myPatients?.patientInfo?.backendusers?.[props.patient];
  if (backendUser) {
    const age = calculateAge(backendUser.patient_birthdate);
    const hasDob = !!backendUser.patient_birthdate;
    let formattedBirth = 'N/A (Click to update)';
    if (backendUser.patient_birthdate) {
      // Format YYYY-MM-DD to MM/DD/YYYY for display
      const [year, month, day] = backendUser.patient_birthdate.split('-');
      formattedBirth = `${month}/${day}/${year} (${age} years old)`;
    }
    const genderDisplay = backendUser.patient_gender && backendUser.patient_gender !== 'N/A'
      ? backendUser.patient_gender
      : 'N/A (Click to update)';
    return {
      gender: genderDisplay,
      age: age !== 'N/A' ? `${age}` : 'N/A',
      formattedBirthWithAge: formattedBirth,
      hasDob,
      dob: backendUser.patient_birthdate,
      race: 'N/A',
      ethnicity: 'N/A'
    };
  }

  return { gender: 'N/A (Click to update)', age: 'N/A', formattedBirthWithAge: 'N/A (Click to update)', hasDob: false, dob: null, race: 'N/A', ethnicity: 'N/A' };
})



</script>


<style scoped>

/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #C4C4C4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              padding-bottom 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #C4C4C4);
  pointer-events: auto;
}

.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}


.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.peg-board-title {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 16px;
}

.peg-board-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  padding: 0 8px;
}

.info-card {
  background-color: white;
  border-radius: 5px;
  padding: 12px 16px;
  box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.info-card-content-col-group {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
}

.info-row-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-container {
  background-color: #f2f2f2;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-style {
  width: 20px;
  height: 20px;
}

.info-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  line-height: 20px;
}

.action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.appointment-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50px;
  height: 64px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
  overflow: hidden;
}

.month {
  background-color: #004879;
  color: white;
  width: 100%;
  text-align: center;
  padding: 2px 0;
  font-size: 14px;
}

.day {
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  text-transform: capitalize;
  height: 24px;
}

.weekday {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1;
  padding-bottom: 3px;
}

.appointment-details {
    flex-grow: 1;
}

.detail-title {
    font-size: 12px;
    color: #666;
}
.detail-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}
.action-icons-appointment {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 20px;
}
.info-text-title {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #666;
}
.info-text-large {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

/* Badge for billing preference */
.badge {
  color: #25B8C2;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
  letter-spacing: 0.25px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.badge-default {
  border-radius: 20px;
  background: #EBFFF8;
  width: 68px;
}

.expand-action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1B79A0;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 5px;
}

.expand-action span {
  color: var(--color-Darkblue-000, #1E4670);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

/* Icon-only buttons with hover text reveal */
.copy-expand,
.variable-expand,
.move-expand {
  display: flex;
  align-items: center;
  width: 26px;
  overflow: hidden;
  padding: 4px;
  justify-content: center;
  transition: width 0.25s ease, padding 0.25s ease, gap 0.25s ease;
  gap: 0;
}

.copy-expand:hover,
.variable-expand:hover,
.move-expand:hover {
  padding: 4px 10px;
  justify-content: flex-start;
  gap: 6px;
}

.copy-expand:hover { width: 74px; }
.variable-expand:hover { width: 160px; }
.move-expand:hover { width: 78px; }

.copy-expand span,
.variable-expand span,
.move-expand span {
  white-space: nowrap;
  opacity: 0;
  min-width: 0;
  transition: opacity 0.2s ease;
  transition-delay: 0.05s;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1E4670;
  text-decoration: underline;
}

.copy-expand:hover span,
.variable-expand:hover span,
.move-expand:hover span {
  opacity: 1;
}

.copy-expand img,
.variable-expand img,
.move-expand img {
  flex-shrink: 0;
}

.action-icon {
  width: 28px;          /* w-7 */
  height: 28px;         /* h-7 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;   /* rounded-[5px] */
  padding: 5px;         /* pd-5 (assuming you meant padding) */
  cursor: pointer;
  transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover,
.expand-action:hover {
  background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}

.dob-editable {
  cursor: pointer;
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.dob-editable:hover {
  background-color: #E5F1FB;
}

.dob-input {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  line-height: 20px;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
  padding: 4px 8px;
  outline: none;
  width: 120px;
}

.dob-input:focus {
  border-color: #25B8C2;
  box-shadow: 0 0 0 2px rgba(37, 184, 194, 0.1);
}

.gender-editable {
  cursor: pointer;
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.gender-editable:hover {
  background-color: #E5F1FB;
}

.gender-select {
  width: 140px;
}

.gender-select :deep(.el-input__wrapper) {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  padding: 2px 8px;
  box-shadow: 0 0 0 1px #C4C4C4 inset;
}

.gender-select :deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #25B8C2 inset, 0 0 0 2px rgba(37, 184, 194, 0.1);
}

.gender-select :deep(.el-input__inner) {
  height: 28px;
  line-height: 28px;
}
</style>
